export const REFETCH_INTERVALS = {
  DEFAULT: 10 * 1000,
  FILE_PROCESSING: 10 * 1000,
  LIVE_USERS: 5 * 1000,
};

export const CSV_UPLOAD_FILE_SIZE_LIMIT = 200099999;
export const CSV_UPLOAD_FILE_SIZE_LIMIT_LABEL = `${Math.round(CSV_UPLOAD_FILE_SIZE_LIMIT / 1_000_000)}MB`;
